module.exports = __webpack_public_path__ + "img/pool_icon_white.8b420cae.svg";